import { render, staticRenderFns } from "./detail_member.vue?vue&type=template&id=79f8f22c&scoped=true&"
import script from "./detail_member.vue?vue&type=script&lang=js&"
export * from "./detail_member.vue?vue&type=script&lang=js&"
import style0 from "./detail_member.vue?vue&type=style&index=0&id=79f8f22c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f8f22c",
  null
  
)

export default component.exports